<template>
  <div class="controllerInput_main"  :class="{'cn':version == '1'}">
    <div class="cont_right">
      <div class="table_box">
        <div class="tr">
          <div class="th" style="width: 5rem;">{{ $t('App.controllerInput.text1') }}</div>
          <div class="th" style="width: 10rem;">{{ $t('App.controllerInput.text2') }}</div>
          <div class="th" style="width: 15rem;">{{ $t('App.controllerInput.text3') }}</div>
          <div class="th" style="width: 15rem;">{{ $t('App.controllerInput.text4') }}</div>
          <div class="th" style="width: 8rem;" v-if="dataType == 'view'">{{ $t('App.controllerInput.text11') }}</div>
          <!-- <div class="th" style="width: 5rem;" v-if="dataType == 'view'">{{ $t('App.controllerInput.text10') }}</div> -->
          <!-- <div class="th" style="width: 18rem;">{{ $t('App.controllerInput.text6') }}</div> -->
          <div class="th" style="width: 18rem;">{{ $t('App.gatewayInput.text11') }}</div>
          <div class="th" style="width: 10rem;">{{ $t('App.controllerInput.text7') }}</div>
          <div class="th" style="width: 8rem;"></div>
          <div class="th_scrollbar"></div>
        </div>
        <div class="tr_td_box scrollbar_style">
          <div class="tr" v-for="(item,index) in lampList" :key="'tr_'+index" @click="textChangeFun($event,item)" style="blackground">
            <div class="td" style="width: 5rem;">
              <span class="text">{{index + 1}}.</span>
            </div>
            <div class="td" style="width: 10rem;">
              <span class="text" v-if="item.dataType == 'text'" :title="item.name">{{ item.name }}</span>
              <el-input class="input1" v-model="item.name" v-if="item.dataType == 'input'"></el-input>
            </div>
            <div class="td" style="width: 15rem;">
              <span class="text" v-if="item.dataType == 'text'" :title="item.address">{{ item.address }}</span>
              <el-input class="input1" v-model="item.address" v-if="item.dataType == 'input'" @click.stop="inputClick()"></el-input>
            </div>
            <div class="td" style="width: 15rem;">
              <span class="text" v-if="item.dataType == 'text'" :title="item.networkAddress">{{ item.networkAddress }}</span>
              <el-input class="input1" v-model="item.networkAddress" v-if="item.dataType == 'input'" @click.stop="inputClick()"></el-input>
            </div>
            <div class="td" style="width: 8rem;" v-if="dataType == 'view'">
              <span class="text" v-if="item.alarmStatus == '0'" :title="alarmStatusArr[item.alarmStatus].name">{{alarmStatusArr[item.alarmStatus].name}}</span>
              <span class="text" v-if="item.alarmStatus == '1'" :title="item.alarmContent">{{item.alarmContent}}</span>
            </div>
            <!-- <div class="td" style="width: 5rem;" v-if="dataType == 'view'">
              <span >{{onlineArr[item.online].name}}</span>
            </div> -->
            <div class="td" style="width: 18rem;">
              <span class="text" v-if="item.dataType == 'text'" :title="item.expirationDate">{{ item.expirationDate }}</span>
              <!-- <el-input class="input1" v-model="item.expirationDate" v-if="item.dataType == 'input'"></el-input> -->
              <el-date-picker
                v-if="item.dataType == 'input'"
                class="date1"
                v-model="item.expirationDate"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="">
              </el-date-picker>
            </div>
            <!-- <div class="td" style="width: 18rem;">
              <span class="text" v-if="item.expirationDate">{{ (item.expirationDate.split(' ')[0].split('-')[0]-1+6)+'-'+item.expirationDate.split(' ')[0].split('-')[1]+'-'+item.expirationDate.split(' ')[0].split('-')[2] +' '+ item.expirationDate.split(' ')[1]}}</span>
            </div> -->
            <div class="td" style="width: 10rem;">
              <span class="text" v-if="item.dataType == 'text'" :title="item.remark">{{ item.remark }}</span>
              <el-input class="input1" v-model="item.remark" v-if="item.dataType == 'input'"></el-input>
            </div>
            <div class="td" style="width: 8rem;">
              <div class="delBtn" @click="lampDel(item,index)" v-loading="item.gatewayDelLoading">{{ $t('App.delete') }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="foot_box">
        <div class="btn_box">
          <div class="btn3 icon" @click="addDevFun" ></div>
          <!-- <div class="btn1" @click="pageTypeFun">{{ $t('App.cancel') }}</div> -->
          <div class="btn1 text" @click="logOut()">{{$t('App.exit')}}</div>
          <div class="btn1 text" @click="edit()" v-if="dataType == 'view'">{{$t('App.edit')}}</div>
          <div class="btn1 text" @click="calcel()" v-if="dataType == 'edit'">{{$t('App.cancel')}}</div>
          <div class="btn2" @click="saveDevFun">{{ $t('App.ok') }}</div>
        </div>
      </div>
    </div>

  <!-- 选择页面 -->
  <el-dialog :show-close="false" :visible.sync="selectVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="36.51rem" class="selection" >
    <el-radio-group style="display: grid;" v-model="getUserSettingInfoDateValue_">
      <el-radio :disabled="getUserSettingInfoDate.sysStatus === 1" label="systemSetting">{{$t('App.status.text0')}}</el-radio>
      <el-radio :disabled="getUserSettingInfoDate.projectStatus === 1" label="projectSettings">{{$t('App.status.text1')}}</el-radio>
      <el-radio :disabled="getUserSettingInfoDate.gatewayStatus === 1" label="gatewayInput">{{$t('App.projectSettings.text5')}}</el-radio>
      <el-radio :disabled="getUserSettingInfoDate.deviceStatus === 1" label="controllerInput">{{$t('App.status.text2')}}</el-radio>
      <el-radio :disabled="getUserSettingInfoDate.groupStatus === 1" label="groupSetting">{{$t('App.status.text3')}}</el-radio>
      <el-radio :disabled="getUserSettingInfoDate.sceneStatus === 1" label="sceneSettingEdit">{{$t('App.status.text4')}}</el-radio>
      <el-radio :disabled="getUserSettingInfoDate.scheduleStatus === 1" label="schedule">{{$t('App.status.text5')}}</el-radio>
    </el-radio-group>
    <span  slot="footer" class="footer">
      <el-button @click="projectSelection()">Enter</el-button>
    </span>
  </el-dialog>

    <!-- 获取用户设置状态信息 -->
    <div class="project_completed" v-if="isShowprojectCompleted">
      <div class="bg"></div>
      <div class="form_box" >
        <div class="span">
          {{$t('App.text14')}}
        </div>
        <div class="btn_box">
          <!-- <div class="btn1" @click="isShowLogout = false">{{$t('App.no')}}</div> -->
          <div class="btn2" @click="projectCompletedClose('groupSetting')">{{$t('App.ok')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapGetters } from 'vuex'
import allUrl from '../api/allUrl.js'
import base from '../api/base.js'
export default {
  name: 'controllerInput',
  data () {
    return {
      dataType:'view',

      formArr: [],
      isShowprojectCompleted: false,
      groupOptions: [],
      lampList:[],
      lampList_:[],
      alarmStatusArr:[],
      onlineArr:[],
      lightGatewayarr:[],
      lightGatewayarr_:[],

			selectVisible: false,
			getUserSettingInfoDateValue_:'systemSetting',
			getUserSettingInfoDate :{
				sysStatus:'',
				projectStatus:'',
				gatewayStatus:'',
				deviceStatus:'',
				groupStatus:'',
				sceneStatus:'',
				scheduleStatus:'',
			},

      // gatewayId:'',
    }
  },
  computed: {
    ...mapGetters({
      token: 'token',
      client_key: 'client_key',
      username: 'username',
      version: 'version',

      lampListUpdate: 'lampListUpdate',
      
      projectId: 'projectId',
      projectName: 'projectName',
      
      remRatio: 'remRatio',
      updateRemRatio: 'updateRemRatio',

      projectUpdate:'projectUpdate',
      
      countryId: 'countryId',
      provinceId: 'provinceId',
      cityId: 'cityId',
      hotelId: 'hotelId',
      headerIdStr: 'headerIdStr',
      themeType: 'themeType',
    }),
    // sensorFormModelName(){
    //     let name = '';
    //     for(let d of this.modelNav){
    //         if(d.id == this.sensorForm.model){
    //             name = d.name
    //         }
    //     }
    //     return name
    // }
  },
  components: {
    // 'sideBar':sideBar
  },
  beforeDestroy () {
  },
  mounted () {
    // this.gatewayConfigWhiteListsGet(25)
    this.getUserSettingInfo();
    this.lampListGet()
    this.formArr = [
      { name: '', id: '', gateway: '', group: [], warrantyPeriod: '', remark: '', dataType: 'text' },
      { name: '', id: '', gateway: '', group: [], warrantyPeriod: '', remark: '', dataType: 'text' },
      { name: '', id: '', gateway: '', group: [], warrantyPeriod: '', remark: '', dataType: 'text' },
      { name: '', id: '', gateway: '', group: [], warrantyPeriod: '', remark: '', dataType: 'text' },
      { name: '', id: '', gateway: '', group: [], warrantyPeriod: '', remark: '', dataType: 'text' },
    ]
    this.alarmStatusArr = [
      { id:'0', name: this.$t('App.controllerInput.text8')},
      { id:'1', name: this.$t('App.controllerInput.text9')},
    ];
    this.onlineArr = [
      { id:'0', name: this.$t('App.home.lightOnline0')},
      { id:'1', name: this.$t('App.home.lightOnline1')},
    ];
  },
  methods: {
    skinClassFun(){
      let obj = {};
      obj['cn'] = this.version == '1';
      // obj['ratio_1920_1080'] = this.ratio == '1';
      if(this.themeType == 1){
        obj['themeType_' + 1] = true;
      }
      // obj['themeType_' + 1] = true;
      return obj
    },
		confirmSelection() {
      this.getUserSettingInfo(data => {
        if (data.isTrue) {
          this.selectVisible = true;
        }
      });
		},
		projectSelection(){
			
			this.$emit('pageTypeFun', this.getUserSettingInfoDateValue_)
			this.selectVisible = false;
		},
    projectCompletedClose(){
      this.isShowprojectCompleted = false
      this.$emit('pageTypeFun','groupSetting')
    },
    //删除灯控
    lampDel(obj,index) {
      if(obj.lampDelLoading){
        return
      }
      for(let key in this.lampList){
        this.lampList[key].id = obj.id;
        
        console.log(this.lampList[key].id,'--11-1-')
        
        
      }
      // this.gatewayId = obj.id;

      this.lampDelLoading = true;
      if(obj.id != -1){
        this.$confirm(this.$t('App.message.text16'), this.$t('App.message.text4'), {
          confirmButtonText: this.$t('App.message.text5'),
          cancelButtonText: this.$t('App.message.text6'),
          type: 'warning'
        }).then(() => {
          base.ajax_post(
            allUrl.lamp.lamp_del,
            {
              username: this.username,
              version: this.version,
              token: this.token,
              id: obj.id,
            },
            {},
            (data) => {
              // this.gatewayListGet();
              this.$message({
                showClose: true,
                message: data.msg,
                type: "success",
              });
              this.lampListGet()
              obj.lampDelLoading = false;
            },
            this,()=>{
              obj.lampDelLoading = false;
            }
          )
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.version === '1' ? '已取消删除' : 'Canceled'
          });
        });

      } else{

        this.lampList.splice(index, 1)
        // this.gatewayList_.splice(index, 1)
      }
    },
		//获取用户设置状态信息
		getUserSettingInfo(callback) {
			// this.selectVisible = true;
			base.ajax_post(
				allUrl.user.user_getUserSettingInfo,
				{
				username: this.username,
				version: this.version,
				token:this.token,
				},
				{},
				data => {
          this.getUserSettingInfoDate = data.data;
          data.isTrue = false;
          if(this.getUserSettingInfoDate.sysStatus == 0){
            this.getUserSettingInfoDateValue_ = 'systemSetting'
            data.isTrue = true
          } else if(this.getUserSettingInfoDate.projectStatus == 0){
            this.getUserSettingInfoDateValue_ = 'projectSettings'
            data.isTrue = true
          }else if(this.getUserSettingInfoDate.gatewayStatus == 0){
            this.getUserSettingInfoDateValue_ = 'gatewayInput'
            data.isTrue = true
          } else if(this.getUserSettingInfoDate.deviceStatus == 0){
            this.getUserSettingInfoDateValue_ = 'controllerInput'
            data.isTrue = true
          } else if(this.getUserSettingInfoDate.groupStatus == 0){
            this.getUserSettingInfoDateValue_ = 'groupSetting'
            data.isTrue = true
          } else if(this.getUserSettingInfoDate.sceneStatus == 0){
            this.getUserSettingInfoDateValue_ = 'sceneSettingEdit'
            data.isTrue = true
          }else if(this.getUserSettingInfoDate.scheduleStatus == 0){
            this.getUserSettingInfoDateValue_ = 'schedule'
            data.isTrue = true
          }
          if(callback){
            callback(data)
          }
				},
				this
			)
		},
    inputClick(){

    },
    textChangeFun(e,obj) {
      console.log(obj)
      // if(obj.dataType == 'input'&&e.target.nodeName!='INPUT'){
      //   obj.dataType = 'text';
      // }
    },
    edit(){
      this.dataType = 'edit';
      for(let d of this.lampList){
        d.dataType = 'input';
      }
    },
    calcel(){
      this.dataType = 'view';
      for(let key in this.lampList){
        this.lampList[key].dataType = 'text';
        
        console.log(this.lampList[key].id,'--11-1-')
        if(this.lampList[key].id == -1){
          this.lampList.splice(key,this.lampList.length-1)
        } 
        // else{
        // }
        
      }
      
    },
    // groupChange (groupArr) {
    //   // console.log(groupArr)
    //   // let isTrue = false;
    //   let arr = [];
    //   // let group = obj.group[obj.group.length-1]
    //   let i = 0;
    //   for (let group of groupArr) {
    //     arr[i] = false;
    //     console.log(group, this.groupOptions)
    //     for (let d of this.groupOptions) {
    //       if (d.id == group) {
    //         // isTrue = true
    //         arr[i] = true;
    //       }
    //     }
    //     i++
    //   }
    //   console.log(arr)
    //   for (let index in arr) {
    //     if (!arr[index]) {
    //       this.groupOptions.push({ id: groupArr[index], name: groupArr[index] })
    //     }
    //   }
    //   console.log(this.groupOptions)
    // },
    pageTypeFun () {
      this.$emit('pageTypeFun', '')
    },
    //退出登录
    logOut(){
      this.$emit('pageTypeFun', '')
    },
    addDevFun(){
      // this.dataType = 'add';
      this.dataType = 'edit';
      this.$set(this.lampList,this.lampList.length,{
        id:'-1',
        dataType:'input',
        online:0,
        alarmStatus:0,
        name:'',
        address:'',
        networkAddress:'',
        expirationDate:'',
        remark:'',
      })
      this.$set(this.lampList_,this.lampList_.length,{
        id:'-1',
        dataType:'input',
        name:'',
        address:'',
        networkAddress:'',
        expirationDate:'',
        remark:'',
      })
    },
    saveDevFun(){
      // let list = [];
      console.log(this.lampList,'6565--')
      // dataType
      let lampList = JSON.parse(JSON.stringify(this.lampList));
      let lampList_ = JSON.parse(JSON.stringify(this.lampList_));
      
      // if(this.lightGatewayarr_ !=this.lightGatewayarr){
      //   this.gatewayConfigWhiteListsGet()
      // }

      for(let key in lampList){
        delete lampList[key].dataType;
        delete lampList_[key].dataType;
        if(lampList[key].id == '-1'){
          this.lampAdd(lampList[key])
          continue;
        }
        console.log(JSON.stringify(lampList[key]),JSON.stringify(lampList_[key]))
        if(JSON.stringify(lampList[key]) != JSON.stringify(lampList_[key])){
          this.lampUpdate(lampList[key])
        }
      }
      
      //  this.lampListGet();
      this.dataType = 'view';
    },
    //组网
    gatewayConfigWhiteListsGet(gatewayId) {
      base.ajax_post(
        allUrl.gateway.gateway_configWhiteLists,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          id: gatewayId
        },
        {},
        (data) => {
          this.$message({
            showClose: true,
            message: data.msg,
            type: "success",
          });
        },
        this
      )
    },
    lampListGet() {
      base.ajax_post(
        allUrl.lamp.lamp_lampList,
        {
          username: this.username,
          version: this.version,
          token:this.token,
          projectId:this.projectId
        },
        {},
        data => {
          console.log(data)
          for(let d of data.data){
            d.dataType = 'text'
          }
          this.lampList = data.data;
          this.lampList_ = JSON.parse(JSON.stringify(data.data));
          console.log(this.lampList)

          this.lightGatewayarr = [];
          this.lampList.forEach((item) => {
            if(item.gatewayId){
              if(this.lightGatewayarr[item.gatewayId]){
                this.lightGatewayarr[item.gatewayId] = this.lightGatewayarr[item.gatewayId] + ',' + item.id;
              }else{
                this.lightGatewayarr[item.gatewayId] = item.id
              }
            }
          });
          console.log(this.lightGatewayarr,'---8888---')
        },
        this
      )
    },
    lampAdd(obj) {
      let d = JSON.parse(JSON.stringify(obj))
      delete d.id;
      delete d.dataType;
      base.ajax_post(
        allUrl.lamp.lamp_add,
        {
          username: this.username,
          version: this.version,
          token:this.token,
          projectId:this.projectId,
          ...d
        },
        {},
        data => {
          let gatewayId = '';
          for(let d of this.lampList){
            if(obj.networkAddress == d.networkAddress){
              gatewayId = d.gatewayId
            }
            d.dataType = 'text'
          }
          if(this.getUserSettingInfoDate.deviceStatus == 0){
            this.confirmSelection()
          }
          // else{
          //   this.$emit('pageTypeFun', '')
          // }
          
          this.$store.commit('projectUpdateFun', {
            projectUpdate: this.projectUpdate+1,
          })

          if(gatewayId){
            this.gatewayConfigWhiteListsGet(gatewayId)
          }
          this.lampList_ = this.lampList;
          this.lampListGet();
          this.$message({
            showClose: true,
            message: data.msg,
            type: 'success'
          });
          this.$store.commit('lampListUpdateFun', {
            lampListUpdate: this.lampListUpdate+1,
          })

          // console.log(this.lampList)
        },
        this
      )
    },
    lampUpdate(obj) {
      let d = JSON.parse(JSON.stringify(obj))
      base.ajax_post(
        allUrl.lamp.lamp_update,
        {
          username: this.username,
          version: this.version,
          token:this.token,
          projectId:this.projectId,
          ...d
        },
        {},
        data => {
          for(let d of this.lampList){
            d.dataType = 'text'
          }
          this.lightGatewayarr_ = [];
          this.lampList.forEach((item) => {
            if(item.gatewayId){
              if(this.lightGatewayarr_[item.gatewayId]){
                this.lightGatewayarr_[item.gatewayId] = this.lightGatewayarr_[item.gatewayId] + ',' + item.id;
              }else{
                this.lightGatewayarr_[item.gatewayId] = item.id
              }
            }
          });
          for(let key in this.lightGatewayarr){
            if(JSON.stringify(this.lightGatewayarr[key]) != JSON.stringify(this.lightGatewayarr_[key])){
              this.gatewayConfigWhiteListsGet(key)
            }
          }
          this.lampListGet();
          this.$message({
            showClose: true,
            message: data.msg,
            type: 'success'
          });
          // console.log(this.lampList)
        },
        this
      )
    },
  },
  watch: {
    projectId:function(){
      this.lampListGet();
    }
  }
}
</script>

<style type="text/css" lang="less">
.controllerInput_main {
  position: absolute;
  top: 5.78rem;
  left: 0;
  width: 100%;
  height: calc(100% - 5.78rem);
  min-height: 50rem;
  margin: 0 auto;
  overflow: hidden;
  // position: relative;
  display: flex;
  // justify-content: end;
  // background: rgba(255, 255, 255, 0.85);
  justify-content: flex-end;
  

  .cont_right {
    // float: left;
    // margin-left: auto;
    // position: absolute;
    // top: 0;
    // right: 0;
    // opacity: 0.9;
    .table_box {
      height: calc(100% - 9rem);
      background: rgba(255, 255, 255, 0.9);
      // width: 76.31rem;
      opacity: 0.9;
      .tr_td_box {
        // opacity: 0.8;
        height: calc(100% - 4.14rem);
        .text{
          overflow:hidden;
          text-overflow:ellipsis;
          white-space:nowrap;

          width: 100%;
          text-overflow: ellipsis;
        }
        // width: calc(100% - 0.5rem);
      }
      .date1{
        width: calc(100% - 1rem);
        height: 3.5rem;
        line-height: 3.5rem;
        .el-input__inner {
          padding-left: 2rem;
          padding-right: 0.5rem;
          width: 100%;
          height: 3.5rem !important;
          line-height: 3.5rem;
          border: 0.09rem solid #3a636f;
          border-radius: 0.44rem;
          background-color: rgba(0, 0, 0, 0);

          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
        }
      }
      .input1 {
        width: calc(100% - 1rem);
        height: 3.5rem;
        line-height: 3.5rem;
        .el-input__inner {
          padding-left: 0.5rem;
          padding-right: 0.5rem;
          width: 100%;
          height: 3.5rem !important;
          line-height: 3.5rem;
          border: 0.09rem solid #3a636f;
          border-radius: 0.44rem;
          background-color: rgba(0, 0, 0, 0);

          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
        }
        .el-select__tags {
          .el-tag--small {
            height: 2.5rem;
            line-height: 2.5rem;
            padding: 0 0.5rem;
            max-width: 7rem;

            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3a636f;
          }
        }
        .el-select__input {
          // padding-left: 0.5rem;
          width: 100%;
          height: 3.5rem;
          line-height: 3.5rem;
          // border: 0.09rem solid #3A636F;
          // border-radius: 0.44rem;
          background-color: rgba(0, 0, 0, 0);

          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
        }
        .el-input__prefix {
          width: 1.8rem;
          height: 1.8rem;
          top: 0.96rem;
          left: 0.79rem;
          .icon {
            width: 100%;
          }
        }
        .el-input__suffix {
          height: 3.5rem;
          line-height: 3.5rem;
          right: 1.49rem;
        }
        .span {
          margin-top: -0.2rem;
          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
          position: relative;
          top: -0.2rem;
        }
        .el-input .el-select__caret {
          font-size: 1.8rem;
          color: rgba(58, 99, 111, 1);
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .tr {
        display: flex;
        align-items: center;
        height: 4.12rem;
        line-height: 4.12rem;
        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: #3a636f;
        // background: rgba(255, 255, 255, 1);
        // opacity: 0.8;
        &:nth-child(2n + 1) {
          // background: rgba(255, 255, 255, 1);
          background: rgba(244, 251, 253, 1);
          opacity: 0.9;
        }
        // &:nth-child(2n) {
        //   background: rgba(255, 255, 255, 1);
        //   opacity: 0.8;
        //   // background: rgba(244, 251, 253, 1);
        // }
        .th:nth-child(1),.tr:nth-child(1){
          text-align: left;
        }
        .th,
        .td {
          text-align: center;
          height: 4.12rem;
          line-height: 4.12rem;
          display: flex;
          align-items: center;
          white-space:nowrap;
          justify-content: space-around;
        }
        // .flex_2 {
        //   flex: 2;
        // }
        .td {
          cursor: pointer;
          &:nth-child(1) {
            padding-left: 1rem;
          }
        }
        .th {
          &:nth-child(1) {
            padding-left: 1rem;
          }
        }
        .th_scrollbar {
          width: 0.5rem;
          height: 100%;
        }
      }
      .delBtn {
        text-align: center;
        min-width: 5.5rem;
        padding: 0 1rem;
        height: 3.13rem;
        line-height: 3.13rem;
        background: #F4FBFD;
        border-radius: 0.2rem;
        border: 0.1rem solid #3A636F;

        font-family: Calibri;
        font-weight: normal;
        font-size: 1.8rem;
        color: #3A636F;
        cursor: pointer;
      }
    }
    .foot_box{
      height: 9rem;
      background: rgba(244, 251, 253, 1);
      opacity: 0.9;
      // padding-left: 30rem;
      display: flex;
      justify-content: flex-end;
      .btn_box{
        display: flex;
        align-items: center;
      }
      .btn1{
        text-align: center;
        min-width: 7.5rem;
        padding: 0 1rem;
        height: 3.13rem;
        line-height: 3.13rem;
        background: #F4FBFD;
        border-radius: 0.2rem;
        border: 0.1rem solid #3A636F;
        
        font-family: Calibri;
        font-weight: normal;
        font-size: 1.8rem;
        color: #3A636F;
        margin-right: 5rem;
        cursor: pointer;
      }
      .btn2{
        text-align: center;
        min-width: 7rem;
        padding: 0 1rem;
        height: 3.13rem;
        line-height: 3.13rem;
        background: #F4FBFD;
        border-radius: 0.2rem;
        border: 0.1rem solid #00C6FF;
        
        background: #00C6FF;

        font-family: Calibri;
        font-weight: normal;
        font-size: 1.8rem;
        color: #FFFFFF;
        margin-right: 7rem;
        cursor: pointer;
      }
      .btn3.icon{
        margin-right: 5rem;
        cursor: pointer;
        width: 4.28rem;
        height: 4.28rem;
        background-image: url(../img/icon/btn_bg1.png);
        background-position: center;
        background-size: 100% 100%;
      }
    }
  }
  .project_completed{
    position: fixed;
    top: 0;right: 0;left: 0;bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    
    .bg{
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0);
      z-index: -1;
      opacity: 0.5;
    }
    .form_box{
      position: relative;
      width: 36.51rem;
      height: 18.09rem;
      padding-top: 2.83rem;
      background: #FFFFFF;
      border: 0px solid #3A636F;
      border-radius: 0.2rem;
      opacity: 0.9;
      .span{
        font-family: Calibri;
        color: #3A636F;
        text-align: center;
        width: 23.22rem;
        font-weight: 400;
        font-size: 1.8rem;
        color: #4C717C;
        margin: auto;
      }
      .btn_box{
        // position: absolute;
        // bottom: 0rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 5.07rem;
        // margin: 4.47rem auto 0;
        // width: 26.69rem;
        
        .btn2{
          width: 6.25rem;
          height: 2.63rem;
          background: #00C6FF;
          border-radius: 0.2rem;

          line-height: 2.63rem;
          border: 0.09rem solid #00C6FF;
          text-align: center;
          // font-family: Calibri;
          // font-weight: normal;
          // color: #FFFFFF;
          cursor: pointer;
          user-select: none;

          font-family: Calibri;
          font-weight: 400;
          font-size: 1.8rem;
          color: #FFFFFF;
        }
      }
    }
  }
}
// .controllerInput_main.themeType_1 {
//   .cont_right {
//     .table_box {
//       background: rgba(250,  237, 218, 0.9);
//       // opacity: 0.9;
//       .date1{
//         .el-input__inner {
//           border: 0.09rem solid #682411;
//           background-color: rgba(0, 0, 0, 0);
//           color: #682411;
//         }
//       }
//       .input1 {
//         .el-input__inner {
//           border: 0.09rem solid #682411;
//           background-color: rgba(0, 0, 0, 0);
//           color: #682411;
//         }
//         .el-select__tags {
//           .el-tag--small {
//             color: #682411;
//           }
//         }
//         .el-select__input {
//           background-color: rgba(0, 0, 0, 0);
//           color: #682411;
//         }
//         .span {
//           color: #682411;
//         }
//         .el-input .el-select__caret {
//           color: #682411;
//         }
//       }
//       .tr {
//         color: #682411;
//         &:nth-child(2n + 1) {
//           background: rgba(250, 237, 218, 0.9);
//           opacity: 0.9;
//         }
//       }
//       .delBtn {
//         background: #f2cd9b;
//         border: 0.1rem solid #682411;
//         color: #682411;
//       }
//     }
//     .foot_box{
//       background: #faedda;
//       .btn1 {
//         background: #f2cd9b;
//         border: 0.1rem solid #682411;
//         color: #682411;
//       }
//       .btn2 {
//         background: #f44336;
//         border: 0.09rem solid #f44336;
//         color: #ffffff;
//       }
//       .btn3.icon{
//         background-image: url(../img/orange/btn_bg1.png);
//       }
//     }
//   }
//   .project_completed{
//     .form_box{
//       background: #FFFFFF;
//       border: 0px solid #3A636F;
//       opacity: 0.9;
//       .span{
//         color: #682411;
//       }
//       .btn_box{
//         .btn2{
//           background: #f44336;
//           border: 0.09rem solid #f44336;
//           color: #ffffff;
//         }
//       }
//     }
//   }
// }
</style>